import StudentFileUpload from "./src/main";

/* istanbul ignore next */
StudentFileUpload.install = function (Vue) {
  Vue.component(StudentFileUpload.name, StudentFileUpload);
};

export default StudentFileUpload;
